// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:08:14
import { Guid, GuidTools } from '@models/guid';
import { BaseObject } from '@models/BaseObject';

export abstract class PflauSpecificPhoneNumberArgs_abstract extends BaseObject {
  static $t: string = 'SagaBase.Defines.PflauSpecificPhoneNumberArgs';
  $t: string = 'SagaBase.Defines.PflauSpecificPhoneNumberArgs';

  public static GetMembers(): string[] {
    return ['PsapId', 'PsapPhone', 'CountryCode', 'IsManual', 'PhoneNumber', 'DisabledPflauSearch', 'FetchAllWithTimeout'];
  }

  public GetMembers(): string[] {
    return PflauSpecificPhoneNumberArgs_abstract.GetMembers();
  }

  public _init(): void {
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/
    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public PsapId: string;
  public PsapPhone: string;
  public CountryCode: string;
  public IsManual: boolean = false;
  public PhoneNumber: string;
  public DisabledPflauSearch: boolean = false;
  public FetchAllWithTimeout: number;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  /*</AUTO_IMPLEMENTATION>*/
}
